<template>
    <div class="assets-transfer">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'announcementsDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">View Announcement</div>
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container mt-5">

            <div class="reference-card">
                <form class="readonly-form" action="">

                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Announcement Title *</label>
                                    <input class="form-control" id="title" type="text" v-model="announcementData.title" readonly>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Status *</label>

                                    <input class="form-control" id="status" type="text" v-model="announcementData.status" readonly>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="date">Announcement Date & Time *</label>
                                    <input class="form-control" id="date" type="text" v-model="announcementData.to_announce_at" readonly>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Target Users *</label>
                                    <input class="form-control" id="target" type="text" v-model="announcementData.target_user" readonly>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Division *</label>

                                    <input class="form-control" id="division" type="text" v-model="announcementData.division_name" readonly>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Region *</label>
                                    <input class="form-control" id="region" type="text" v-model="announcementData.region_name" readonly>

                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Area *</label>
                                    <input class="form-control" id="area" type="text" v-model="announcementData.area_name" readonly>

                                </div>
                            </div>
                        </div>


                        <div class="form-group mt-4 mb-2">
                            <label>Announcement</label>
                            <div class="form-control editor-content">
                                {{ announcementData.message }}
                            </div>
                        </div>

                    </div>

                </form>
            </div>

            <button type="button" class="mt-3 btn btn-ecdc btn-shadow" @click="edit(announcementData.id)">Edit</button>
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import Loader from "./Loader";
import {getAnnouncement} from "../api";

export default {
    components: {
        appLoader: Loader,
    },
    data() {
        return {
            announcementData: '',
            isLoading: true,
            id: '',
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.getAnnouncement();

        this.isLoading = false;
    },
    methods: {
        async getAnnouncement() {

            try {

                const result = await getAnnouncement(this.id);
                this.announcementData = result.data.announcement;
                this.announcementData.status = (this.announcementData.status === 0) ? 'Active' : 'Inactive';

            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        edit(id) {

            this.$router.push({ name: "announcementsEdit" , params: { 'id': id }}) ;
        },
    }
}
</script>